
import Vue from "vue";
import HeaderDropDownFilter from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  status?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
};

export default Vue.extend({
  name: "WebsiteListHeader",

  components: {
    HeaderDropDownFilter,
  },

  data(): DataType {
    return {
      filterCondition: {
        status: undefined,
      },
    };
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  },

  methods: {
    updateFilterConditionAndSearch(): void {
      this.$emit("update-filter-condition", this.filterCondition);
      this.$emit("search");
    },
  },
});
